module.exports = __webpack_public_path__ + "img/symmetry-good.ebe51265.svg";